import clone from 'lodash.clonedeep';
import { toImageUrl } from '../utils/format.util';

export default class FeedService {
  constructor(firebase) {
    this.firebase = firebase;
  }

  async getPost(id) {
    const doc = await this.firebase.firestore()
      .collection('posts')
      .doc(id)
      .get();

    if (!doc || !doc.exists || !doc.data()) {
      return null;
    }

    const post = {
      id: doc.id,
      ...doc.data(),
      date: doc.data().date ? doc.data().date.toDate() : null,
    };

    return post;
  }

  async createOrUpdate(post) {
    const postToSave = clone(post);

    delete postToSave.id;

    postToSave.image = typeof post.image === 'string' ? post.image : '';

    let { id } = post;

    if (post.id) {
      await this.firebase.firestore()
        .collection('posts')
        .doc(post.id)
        .update(postToSave);
    } else {
      postToSave.date = new Date();

      const doc = await this.firebase.firestore()
        .collection('posts')
        .add(postToSave);

      id = doc.id;
    }

    if (post.image && (post.image.name || post.image.size)) {
      const path = `posts/${id}`;
      const imageRef = this.firebase.storage().ref().child(path);
      await imageRef.put(post.image);

      await this.firebase.firestore()
        .collection('posts')
        .doc(id)
        .update({
          image: toImageUrl(path),
        });
    }

    return id;
  }

  async deletePost(id) {
    return this.firebase.firestore()
      .collection('posts')
      .doc(id)
      .delete();
  }
}
